/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as PublicEntrarRouteImport } from './routes/_public/entrar'
import { Route as AuthenticatedSubscriptionRouteImport } from './routes/_authenticated/subscription'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPreferencesRouteImport } from './routes/_authenticated/preferences'
import { Route as AuthenticatedLigasRouteImport } from './routes/_authenticated/ligas'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedSobreviventeIndexRouteImport } from './routes/_authenticated/sobrevivente/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedSobreviventeNewRouteImport } from './routes/_authenticated/sobrevivente/new'
import { Route as AuthenticatedLeagueNewRouteImport } from './routes/_authenticated/league/new'
import { Route as AuthenticatedAdminSobreviventeRouteImport } from './routes/_authenticated/admin/sobrevivente'
import { Route as AuthenticatedAdminPersonsRouteImport } from './routes/_authenticated/admin/persons'
import { Route as AuthenticatedAdminFantasyRouteImport } from './routes/_authenticated/admin/fantasy'
import { Route as AuthenticatedSobreviventeGameIdIndexRouteImport } from './routes/_authenticated/sobrevivente/$gameId/index'
import { Route as AuthenticatedLeagueLeagueIdIndexRouteImport } from './routes/_authenticated/league/$leagueId/index'
import { Route as AuthenticatedSobreviventeGameIdSettingsRouteImport } from './routes/_authenticated/sobrevivente/$gameId/settings'
import { Route as AuthenticatedAdminGameweekGameweekIdRouteImport } from './routes/_authenticated/admin/gameweek.$gameweekId'
import { Route as AuthenticatedLeagueLeagueIdTeamUserIdRouteImport } from './routes/_authenticated/league/$leagueId/team/$userId'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicEntrarRoute = PublicEntrarRouteImport.update({
  id: '/entrar',
  path: '/entrar',
  getParentRoute: () => PublicRoute,
} as any)
const AuthenticatedSubscriptionRoute =
  AuthenticatedSubscriptionRouteImport.update({
    id: '/subscription',
    path: '/subscription',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPreferencesRoute =
  AuthenticatedPreferencesRouteImport.update({
    id: '/preferences',
    path: '/preferences',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLigasRoute = AuthenticatedLigasRouteImport.update({
  id: '/ligas',
  path: '/ligas',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSobreviventeIndexRoute =
  AuthenticatedSobreviventeIndexRouteImport.update({
    id: '/sobrevivente/',
    path: '/sobrevivente/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedAdminRoute,
} as any)
const AuthenticatedSobreviventeNewRoute =
  AuthenticatedSobreviventeNewRouteImport.update({
    id: '/sobrevivente/new',
    path: '/sobrevivente/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeagueNewRoute = AuthenticatedLeagueNewRouteImport.update({
  id: '/league/new',
  path: '/league/new',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAdminSobreviventeRoute =
  AuthenticatedAdminSobreviventeRouteImport.update({
    id: '/sobrevivente',
    path: '/sobrevivente',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminPersonsRoute =
  AuthenticatedAdminPersonsRouteImport.update({
    id: '/persons',
    path: '/persons',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedAdminFantasyRoute =
  AuthenticatedAdminFantasyRouteImport.update({
    id: '/fantasy',
    path: '/fantasy',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedSobreviventeGameIdIndexRoute =
  AuthenticatedSobreviventeGameIdIndexRouteImport.update({
    id: '/sobrevivente/$gameId/',
    path: '/sobrevivente/$gameId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedLeagueLeagueIdIndexRoute =
  AuthenticatedLeagueLeagueIdIndexRouteImport.update({
    id: '/league/$leagueId/',
    path: '/league/$leagueId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSobreviventeGameIdSettingsRoute =
  AuthenticatedSobreviventeGameIdSettingsRouteImport.update({
    id: '/sobrevivente/$gameId/settings',
    path: '/sobrevivente/$gameId/settings',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminGameweekGameweekIdRoute =
  AuthenticatedAdminGameweekGameweekIdRouteImport.update({
    id: '/gameweek/$gameweekId',
    path: '/gameweek/$gameweekId',
    getParentRoute: () => AuthenticatedAdminRoute,
  } as any)
const AuthenticatedLeagueLeagueIdTeamUserIdRoute =
  AuthenticatedLeagueLeagueIdTeamUserIdRouteImport.update({
    id: '/league/$leagueId/team/$userId',
    path: '/league/$leagueId/team/$userId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/admin': typeof AuthenticatedAdminRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/ligas': typeof AuthenticatedLigasRoute
  '/preferences': typeof AuthenticatedPreferencesRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/entrar': typeof PublicEntrarRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/fantasy': typeof AuthenticatedAdminFantasyRoute
  '/admin/persons': typeof AuthenticatedAdminPersonsRoute
  '/admin/sobrevivente': typeof AuthenticatedAdminSobreviventeRoute
  '/league/new': typeof AuthenticatedLeagueNewRoute
  '/sobrevivente/new': typeof AuthenticatedSobreviventeNewRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/sobrevivente/': typeof AuthenticatedSobreviventeIndexRoute
  '/admin/gameweek/$gameweekId': typeof AuthenticatedAdminGameweekGameweekIdRoute
  '/sobrevivente/$gameId/settings': typeof AuthenticatedSobreviventeGameIdSettingsRoute
  '/league/$leagueId/': typeof AuthenticatedLeagueLeagueIdIndexRoute
  '/sobrevivente/$gameId/': typeof AuthenticatedSobreviventeGameIdIndexRoute
  '/league/$leagueId/team/$userId': typeof AuthenticatedLeagueLeagueIdTeamUserIdRoute
}
export interface FileRoutesByTo {
  '/': typeof PublicIndexRoute
  '/home': typeof AuthenticatedHomeRoute
  '/ligas': typeof AuthenticatedLigasRoute
  '/preferences': typeof AuthenticatedPreferencesRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/subscription': typeof AuthenticatedSubscriptionRoute
  '/entrar': typeof PublicEntrarRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/admin/fantasy': typeof AuthenticatedAdminFantasyRoute
  '/admin/persons': typeof AuthenticatedAdminPersonsRoute
  '/admin/sobrevivente': typeof AuthenticatedAdminSobreviventeRoute
  '/league/new': typeof AuthenticatedLeagueNewRoute
  '/sobrevivente/new': typeof AuthenticatedSobreviventeNewRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/sobrevivente': typeof AuthenticatedSobreviventeIndexRoute
  '/admin/gameweek/$gameweekId': typeof AuthenticatedAdminGameweekGameweekIdRoute
  '/sobrevivente/$gameId/settings': typeof AuthenticatedSobreviventeGameIdSettingsRoute
  '/league/$leagueId': typeof AuthenticatedLeagueLeagueIdIndexRoute
  '/sobrevivente/$gameId': typeof AuthenticatedSobreviventeGameIdIndexRoute
  '/league/$leagueId/team/$userId': typeof AuthenticatedLeagueLeagueIdTeamUserIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_authenticated/admin': typeof AuthenticatedAdminRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/ligas': typeof AuthenticatedLigasRoute
  '/_authenticated/preferences': typeof AuthenticatedPreferencesRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/subscription': typeof AuthenticatedSubscriptionRoute
  '/_public/entrar': typeof PublicEntrarRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_public/': typeof PublicIndexRoute
  '/_authenticated/admin/fantasy': typeof AuthenticatedAdminFantasyRoute
  '/_authenticated/admin/persons': typeof AuthenticatedAdminPersonsRoute
  '/_authenticated/admin/sobrevivente': typeof AuthenticatedAdminSobreviventeRoute
  '/_authenticated/league/new': typeof AuthenticatedLeagueNewRoute
  '/_authenticated/sobrevivente/new': typeof AuthenticatedSobreviventeNewRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/sobrevivente/': typeof AuthenticatedSobreviventeIndexRoute
  '/_authenticated/admin/gameweek/$gameweekId': typeof AuthenticatedAdminGameweekGameweekIdRoute
  '/_authenticated/sobrevivente/$gameId/settings': typeof AuthenticatedSobreviventeGameIdSettingsRoute
  '/_authenticated/league/$leagueId/': typeof AuthenticatedLeagueLeagueIdIndexRoute
  '/_authenticated/sobrevivente/$gameId/': typeof AuthenticatedSobreviventeGameIdIndexRoute
  '/_authenticated/league/$leagueId/team/$userId': typeof AuthenticatedLeagueLeagueIdTeamUserIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/home'
    | '/ligas'
    | '/preferences'
    | '/profile'
    | '/subscription'
    | '/entrar'
    | '/auth/callback'
    | '/admin/fantasy'
    | '/admin/persons'
    | '/admin/sobrevivente'
    | '/league/new'
    | '/sobrevivente/new'
    | '/admin/'
    | '/sobrevivente/'
    | '/admin/gameweek/$gameweekId'
    | '/sobrevivente/$gameId/settings'
    | '/league/$leagueId/'
    | '/sobrevivente/$gameId/'
    | '/league/$leagueId/team/$userId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/home'
    | '/ligas'
    | '/preferences'
    | '/profile'
    | '/subscription'
    | '/entrar'
    | '/auth/callback'
    | '/admin/fantasy'
    | '/admin/persons'
    | '/admin/sobrevivente'
    | '/league/new'
    | '/sobrevivente/new'
    | '/admin'
    | '/sobrevivente'
    | '/admin/gameweek/$gameweekId'
    | '/sobrevivente/$gameId/settings'
    | '/league/$leagueId'
    | '/sobrevivente/$gameId'
    | '/league/$leagueId/team/$userId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_public'
    | '/_authenticated/admin'
    | '/_authenticated/home'
    | '/_authenticated/ligas'
    | '/_authenticated/preferences'
    | '/_authenticated/profile'
    | '/_authenticated/subscription'
    | '/_public/entrar'
    | '/auth/callback'
    | '/_public/'
    | '/_authenticated/admin/fantasy'
    | '/_authenticated/admin/persons'
    | '/_authenticated/admin/sobrevivente'
    | '/_authenticated/league/new'
    | '/_authenticated/sobrevivente/new'
    | '/_authenticated/admin/'
    | '/_authenticated/sobrevivente/'
    | '/_authenticated/admin/gameweek/$gameweekId'
    | '/_authenticated/sobrevivente/$gameId/settings'
    | '/_authenticated/league/$leagueId/'
    | '/_authenticated/sobrevivente/$gameId/'
    | '/_authenticated/league/$leagueId/team/$userId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/entrar': {
      id: '/_public/entrar'
      path: '/entrar'
      fullPath: '/entrar'
      preLoaderRoute: typeof PublicEntrarRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_authenticated/subscription': {
      id: '/_authenticated/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof AuthenticatedSubscriptionRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/preferences': {
      id: '/_authenticated/preferences'
      path: '/preferences'
      fullPath: '/preferences'
      preLoaderRoute: typeof AuthenticatedPreferencesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/ligas': {
      id: '/_authenticated/ligas'
      path: '/ligas'
      fullPath: '/ligas'
      preLoaderRoute: typeof AuthenticatedLigasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin': {
      id: '/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthenticatedAdminRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sobrevivente/': {
      id: '/_authenticated/sobrevivente/'
      path: '/sobrevivente'
      fullPath: '/sobrevivente/'
      preLoaderRoute: typeof AuthenticatedSobreviventeIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/sobrevivente/new': {
      id: '/_authenticated/sobrevivente/new'
      path: '/sobrevivente/new'
      fullPath: '/sobrevivente/new'
      preLoaderRoute: typeof AuthenticatedSobreviventeNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/league/new': {
      id: '/_authenticated/league/new'
      path: '/league/new'
      fullPath: '/league/new'
      preLoaderRoute: typeof AuthenticatedLeagueNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/sobrevivente': {
      id: '/_authenticated/admin/sobrevivente'
      path: '/sobrevivente'
      fullPath: '/admin/sobrevivente'
      preLoaderRoute: typeof AuthenticatedAdminSobreviventeRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/persons': {
      id: '/_authenticated/admin/persons'
      path: '/persons'
      fullPath: '/admin/persons'
      preLoaderRoute: typeof AuthenticatedAdminPersonsRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/admin/fantasy': {
      id: '/_authenticated/admin/fantasy'
      path: '/fantasy'
      fullPath: '/admin/fantasy'
      preLoaderRoute: typeof AuthenticatedAdminFantasyRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/sobrevivente/$gameId/': {
      id: '/_authenticated/sobrevivente/$gameId/'
      path: '/sobrevivente/$gameId'
      fullPath: '/sobrevivente/$gameId/'
      preLoaderRoute: typeof AuthenticatedSobreviventeGameIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/league/$leagueId/': {
      id: '/_authenticated/league/$leagueId/'
      path: '/league/$leagueId'
      fullPath: '/league/$leagueId/'
      preLoaderRoute: typeof AuthenticatedLeagueLeagueIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/sobrevivente/$gameId/settings': {
      id: '/_authenticated/sobrevivente/$gameId/settings'
      path: '/sobrevivente/$gameId/settings'
      fullPath: '/sobrevivente/$gameId/settings'
      preLoaderRoute: typeof AuthenticatedSobreviventeGameIdSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/gameweek/$gameweekId': {
      id: '/_authenticated/admin/gameweek/$gameweekId'
      path: '/gameweek/$gameweekId'
      fullPath: '/admin/gameweek/$gameweekId'
      preLoaderRoute: typeof AuthenticatedAdminGameweekGameweekIdRouteImport
      parentRoute: typeof AuthenticatedAdminRoute
    }
    '/_authenticated/league/$leagueId/team/$userId': {
      id: '/_authenticated/league/$leagueId/team/$userId'
      path: '/league/$leagueId/team/$userId'
      fullPath: '/league/$leagueId/team/$userId'
      preLoaderRoute: typeof AuthenticatedLeagueLeagueIdTeamUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedAdminRouteChildren {
  AuthenticatedAdminFantasyRoute: typeof AuthenticatedAdminFantasyRoute
  AuthenticatedAdminPersonsRoute: typeof AuthenticatedAdminPersonsRoute
  AuthenticatedAdminSobreviventeRoute: typeof AuthenticatedAdminSobreviventeRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedAdminGameweekGameweekIdRoute: typeof AuthenticatedAdminGameweekGameweekIdRoute
}

const AuthenticatedAdminRouteChildren: AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminFantasyRoute: AuthenticatedAdminFantasyRoute,
  AuthenticatedAdminPersonsRoute: AuthenticatedAdminPersonsRoute,
  AuthenticatedAdminSobreviventeRoute: AuthenticatedAdminSobreviventeRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedAdminGameweekGameweekIdRoute:
    AuthenticatedAdminGameweekGameweekIdRoute,
}

const AuthenticatedAdminRouteWithChildren =
  AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedAdminRoute: typeof AuthenticatedAdminRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedLigasRoute: typeof AuthenticatedLigasRoute
  AuthenticatedPreferencesRoute: typeof AuthenticatedPreferencesRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSubscriptionRoute: typeof AuthenticatedSubscriptionRoute
  AuthenticatedLeagueNewRoute: typeof AuthenticatedLeagueNewRoute
  AuthenticatedSobreviventeNewRoute: typeof AuthenticatedSobreviventeNewRoute
  AuthenticatedSobreviventeIndexRoute: typeof AuthenticatedSobreviventeIndexRoute
  AuthenticatedSobreviventeGameIdSettingsRoute: typeof AuthenticatedSobreviventeGameIdSettingsRoute
  AuthenticatedLeagueLeagueIdIndexRoute: typeof AuthenticatedLeagueLeagueIdIndexRoute
  AuthenticatedSobreviventeGameIdIndexRoute: typeof AuthenticatedSobreviventeGameIdIndexRoute
  AuthenticatedLeagueLeagueIdTeamUserIdRoute: typeof AuthenticatedLeagueLeagueIdTeamUserIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedLigasRoute: AuthenticatedLigasRoute,
  AuthenticatedPreferencesRoute: AuthenticatedPreferencesRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSubscriptionRoute: AuthenticatedSubscriptionRoute,
  AuthenticatedLeagueNewRoute: AuthenticatedLeagueNewRoute,
  AuthenticatedSobreviventeNewRoute: AuthenticatedSobreviventeNewRoute,
  AuthenticatedSobreviventeIndexRoute: AuthenticatedSobreviventeIndexRoute,
  AuthenticatedSobreviventeGameIdSettingsRoute:
    AuthenticatedSobreviventeGameIdSettingsRoute,
  AuthenticatedLeagueLeagueIdIndexRoute: AuthenticatedLeagueLeagueIdIndexRoute,
  AuthenticatedSobreviventeGameIdIndexRoute:
    AuthenticatedSobreviventeGameIdIndexRoute,
  AuthenticatedLeagueLeagueIdTeamUserIdRoute:
    AuthenticatedLeagueLeagueIdTeamUserIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface PublicRouteChildren {
  PublicEntrarRoute: typeof PublicEntrarRoute
  PublicIndexRoute: typeof PublicIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicEntrarRoute: PublicEntrarRoute,
  PublicIndexRoute: PublicIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
